import { Link, useSearchParams } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import {
  GraduationCap,
  CheckCircle2,
  XCircle,
  ArrowRight,
  RotateCcw,
  Clock
} from 'lucide-react'

export function PaymentSuccess() {
  const { user } = useAuth()
  const [searchParams] = useSearchParams()
  const order = searchParams.get('order')

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex flex-col">
      <header className="bg-white border-b">
        <div className="container mx-auto px-4 py-4">
          <Link to="/" className="flex items-center gap-2">
            <GraduationCap className="w-8 h-8 text-primary" />
            <span className="text-xl font-bold">
              Nomad<span className="text-[#EF4135]">Lexis</span>
            </span>
          </Link>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 className="w-12 h-12 text-green-600" />
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-3">
            ¡Pago exitoso!
          </h1>

          <p className="text-lg text-gray-600 mb-2">
            Tu inscripción al Programa Completo ha sido confirmada.
          </p>

          {order && (
            <p className="text-sm text-gray-400 mb-8">
              Número de orden: {order}
            </p>
          )}

          <div className="bg-white rounded-xl border p-6 mb-6 text-left">
            <h3 className="font-semibold text-gray-900 mb-3">
              Próximos pasos
            </h3>
            <ul className="space-y-3 text-sm text-gray-600">
              <li className="flex items-start gap-2">
                <span className="text-green-500 mt-0.5">1.</span>
                Tu pago ha sido recibido exitosamente
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-500 mt-0.5">2.</span>
                Estamos preparando tu plataforma. En breve tendrás acceso completo
              </li>
              <li className="flex items-start gap-2">
                <span className="text-green-500 mt-0.5">3.</span>
                Mientras tanto, puedes seguir practicando con el contenido gratuito
              </li>
            </ul>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-8 flex items-center gap-3">
            <Clock className="w-5 h-5 text-blue-500 shrink-0" />
            <p className="text-sm text-blue-700 text-left">
              Recibirás acceso completo a las 4 unidades, talleres en vivo y exámenes una vez que tu plataforma esté lista.
            </p>
          </div>

          <Link
            to={user ? '/dashboard' : '/login'}
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary text-white rounded-xl font-semibold hover:bg-primary/90 transition-colors"
          >
            Ir al panel
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </div>
  )
}

export function PaymentError() {
  const [searchParams] = useSearchParams()
  const reason = searchParams.get('reason')

  const getMessage = () => {
    switch (reason) {
      case 'cancelled':
        return 'El pago fue cancelado. No se realizó ningún cargo.'
      case 'rejected':
        return 'El pago fue rechazado. Verifica tus datos e intenta nuevamente.'
      default:
        return 'Ocurrió un error durante el pago. Intenta nuevamente.'
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-red-50 to-white flex flex-col">
      <header className="bg-white border-b">
        <div className="container mx-auto px-4 py-4">
          <Link to="/" className="flex items-center gap-2">
            <GraduationCap className="w-8 h-8 text-primary" />
            <span className="text-xl font-bold">
              Nomad<span className="text-[#EF4135]">Lexis</span>
            </span>
          </Link>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-red-500" />
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-3">
            Pago no realizado
          </h1>

          <p className="text-lg text-gray-600 mb-8">
            {getMessage()}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/planes"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary text-white rounded-xl font-semibold hover:bg-primary/90 transition-colors"
            >
              <RotateCcw className="w-5 h-5" />
              Reintentar
            </Link>
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
            >
              Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
